module.exports = __webpack_public_path__ + "img/logo-help.2feb9209.png";